import * as React from 'react';

export const Loadable = (loader) => {
  return React.lazy(loader);
};
